<template>
    <!-- 公司资质  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'license',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--52.png",
        }
    },
    computed: {
        title() {
            return this.$t('license.title');
        },
        subtitle() {
            return this.$t('license.subtitle');
        },
        description() {
            return this.$t('license.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }
}
</script>